import { $, Swiper, gsap } from "../shared/globals.js";

export function createCardStackSliderFeature({ prefersReducedMotion }) {
    const instances = [];

    function handlePointerDown() {
        resetMouseFollow.call(this);
        $(this).addClass("is-card-pointer-down");
    }

    function handlePointerUp() {
        $(".card-stack-slider.card-stack-swiper").removeClass("is-card-pointer-down");
    }

    function isPointInsideRect(x, y, rect) {
        return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
    }

    function updateMouseFollow(event) {
        const $slider = $(this);
        const setters = $slider.data("cardStackMouseSetters");
        if (!setters || $slider.hasClass("is-card-pointer-down")) {
            return;
        }

        const rect = this.getBoundingClientRect();
        if (!rect.width || !rect.height) {
            return;
        }

        const normalizedX = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
        const normalizedY = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
        const clampedX = Math.max(-1, Math.min(1, normalizedX));
        const clampedY = Math.max(-1, Math.min(1, normalizedY));

        setters.x(clampedX);
        setters.y(clampedY);
    }

    function resetMouseFollow() {
        const setters = $(this).data("cardStackMouseSetters");
        if (!setters) {
            return;
        }

        setters.x(0);
        setters.y(0);
    }

    function isHoveringExposedCard(slider, clientX, clientY) {
        const swiper = slider.data("cardStackSwiperInstance");
        if (!swiper || swiper.destroyed || swiper.slides.length < 2) {
            return false;
        }

        const activeSlide = swiper.slides[swiper.activeIndex];
        const nextSlide = swiper.slides[swiper.activeIndex + 1] || swiper.slides[0];
        if (!activeSlide || !nextSlide) {
            return false;
        }

        const activeRect = activeSlide.getBoundingClientRect();
        const nextRect = nextSlide.getBoundingClientRect();

        return isPointInsideRect(clientX, clientY, nextRect) && !isPointInsideRect(clientX, clientY, activeRect);
    }

    function handleExposedCardClick(event) {
        const swiper = $(this).data("cardStackSwiperInstance");
        if (!swiper || swiper.destroyed || swiper.animating || swiper.slides.length < 2) {
            return;
        }

        const activeSlide = swiper.slides[swiper.activeIndex];
        const nextSlide = swiper.slides[swiper.activeIndex + 1] || swiper.slides[0];
        if (!activeSlide || !nextSlide) {
            return;
        }

        const clickX = event.clientX;
        const clickY = event.clientY;
        if (!isHoveringExposedCard($(this), clickX, clickY)) {
            return;
        }

        event.preventDefault();
        swiper.slideNext();
    }

    function prepareSlider($slider) {
        if ($slider.data("cardStackPrepared")) {
            return $slider.children(".swiper-wrapper");
        }

        const $cards = $slider.children(".card-animation-item");
        if ($cards.length < 2) {
            return null;
        }

        const $wrapper = $('<div class="swiper-wrapper"></div>');

        $cards.each(function() {
            if (!$(this).children(".card-stack-card-inner").length) {
                $(this).wrapInner('<div class="card-stack-card-inner"></div>');
            }

            $(this).addClass("swiper-slide");
            $wrapper.append(this);
        });

        $slider.addClass("swiper card-stack-swiper");
        $slider.append($wrapper);
        $slider.data("cardStackPrepared", true);

        return $wrapper;
    }

    function init() {
        if (!Swiper) return;

        $(".js-card-stack-slider").each(function(index) {
            const $slider = $(this);
            const isMobile = window.innerWidth <= 767;
            const dragThreshold = isMobile ? 14 : 28;
            const touchRatio = isMobile ? 0.9 : 0.72;
            const perSlideOffset = isMobile ? 10 : 14;

            if ($slider.data("cardStackSwiperInstance")) {
                return;
            }

            const $wrapper = prepareSlider($slider);
            if (!$wrapper || !$wrapper.children(".swiper-slide").length) {
                return;
            }

            const swiper = new Swiper(this, {
                effect: "cards",
                slidesPerView: 1,
                initialSlide: 0,
                speed: prefersReducedMotion ? 250 : 900,
                rewind: true,
                loop: false,
                allowTouchMove: true,
                simulateTouch: true,
                followFinger: true,
                threshold: dragThreshold,
                touchRatio,
                longSwipesRatio: 0.34,
                resistanceRatio: 0.85,
                watchOverflow: true,
                grabCursor: false,
                touchStartPreventDefault: false,
                preventClicks: true,
                preventClicksPropagation: true,
                cardsEffect: {
                    slideShadows: false,
                    rotate: !prefersReducedMotion,
                    perSlideRotate: prefersReducedMotion ? 0 : 1.2,
                    perSlideOffset,
                },
            });

            if (!prefersReducedMotion && gsap && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
                $slider.data("cardStackMouseSetters", {
                    x: gsap.quickTo(this, "--card-stack-mouse-x", {
                        duration: 0.45,
                        ease: "power3.out",
                    }),
                    y: gsap.quickTo(this, "--card-stack-mouse-y", {
                        duration: 0.55,
                        ease: "power3.out",
                    }),
                });

                $slider.on("mousemove.card-stack pointermove.card-stack", updateMouseFollow);
                $slider.on("mouseleave.card-stack pointerleave.card-stack", resetMouseFollow);
            }

            $slider.on("pointerdown.card-stack mousedown.card-stack", handlePointerDown);
            $slider.on("click.card-stack", handleExposedCardClick);
            $slider.attr("data-card-stack-slider-index", index);
            $slider.data("cardStackSwiperInstance", swiper);
            instances.push(swiper);
        });

        $(document).off("pointerup.card-stack pointercancel.card-stack mouseup.card-stack");
        $(document).on("pointerup.card-stack pointercancel.card-stack mouseup.card-stack", handlePointerUp);
    }

    function destroy() {
        instances.forEach((instance) => {
            instance.destroy(true, true);
        });

        instances.length = 0;

        $(".card-stack-slider")
            .removeData("cardStackMouseSetters")
            .removeData("cardStackSwiperInstance")
            .removeClass("is-card-pointer-down")
            .off(".card-stack");

        $(document).off("pointerup.card-stack pointercancel.card-stack mouseup.card-stack");
    }

    return {
        init,
        destroy,
    };
}
